import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'open-app',
  setup(__props) {

onMounted(() => {
    var btn = document.getElementById('launch-btn')
    btn.addEventListener('launch', function (e) {
        console.log('success')
    })
    btn.addEventListener('error', function (e) {
        // @ts-ignore
        console.log('fail', e.detail)
    })
})

return { __sfc: true, }
}

})